import { GameId } from '@bg-shared/enums/GameId';

type IDefaultConfig = Record<string, unknown>;

export const getBrandedConfig = <T = IDefaultConfig>(gameId: GameId): T =>
    _featuresConfig.brandedConfig && (_featuresConfig.brandedConfig[gameId] as T);
